import { useIntl } from 'react-intl';
import AccionaTable from '../../../components/AccionaTable';
import { getUsers, deleteUser } from '../../../services/redux/users/actions';
import { COLUMNS_HEADERS } from './columns';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import AccionaTableButton from '../../../components/AccionaTable/AccionaTableButton';
import WithBackButton from '../../../layout/WithBackButton';
import AccionaButton from '../../../components/AccionaButton';
import RemoveModal from '../../../components/RemoveModal';
import PropTypes from '../../../utils/propTypes';
import { updateIsActiveUser } from '../../../services/api/auth';
import { Switch } from 'antd';

const List = ({ getItems }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [showRemoveModal, setShowRemoveModal] = useState();

  const onSingleDeleteButtonClick = (user) => {
    setSelectedRows([user]);
    setShowRemoveModal(true);
  };

  const handleOnBulkDeleting = () => {
    setShowRemoveModal(false);
    dispatch(deleteUser(selectedRows[0]));
    setSelectedRows([]);
  };

  const handleOnClickEdit = (user) => {
    navigate('edit/'.concat(user.id));
  };
  const handleOnToggleActive = async (user) => {
    const response = await updateIsActiveUser(user.id);

    if (response.status === 200) {
      getItems();
      window.location.reload();
    }
  };

  return (
    <>
      <div className="row">
        <div
          className="col-sm-12"
          style={{ textAlign: 'right', marginBottom: '10px' }}
        >
          <AccionaButton
            msg={intl.formatMessage({
              id: 'users.create.new.button',
            })}
            classIcon="fas fa-plus"
            onClick={() => {
              navigate('create');
            }}
            style={{ margin: 0 }}
          />
        </div>
      </div>
      <AccionaTable
        columns={COLUMNS_HEADERS}
        getItems={getItems}
        entity="users"
        actions={(user) => (
          <>
            <AccionaTableButton
              onClick={() => handleOnClickEdit(user)}
              type="edit"
              toolTip={intl.formatMessage({
                id: 'editAction.user',
              })}
            />
            <AccionaTableButton
              onClick={() => onSingleDeleteButtonClick(user)}
              type="delete"
              toolTip={intl.formatMessage({
                id: 'deleteAction.users',
              })}
              disabled={user.id === 2}
            />
            <Switch
              style={{ marginLeft: 5 }}
              checked={user.is_active}
              onChange={() => handleOnToggleActive(user)}
            />
          </>
        )}
      />
      <RemoveModal
        entity="users"
        selectedRows={selectedRows}
        msg={intl.formatMessage(
          { id: 'delete.users' },
          { total: selectedRows.length },
        )}
        onOk={handleOnBulkDeleting}
        onCancel={() => setShowRemoveModal((prev) => !prev)}
        hidden={!showRemoveModal}
      />
    </>
  );
};

List.propTypes = {
  getItems: PropTypes.func.isRequired,
};

export default connect(() => ({}), { getItems: getUsers })(
  WithBackButton(List),
);
